import { mapTournament } from "db/mapping/tournament/FsTournament";
import { FsTournament } from "db/model/tournament/FsTournament";
import { db } from "firebase-config";
import { onSnapshot, collection } from "firebase/firestore";
import { store } from "app/store";
import {
  trackTournaments,
  updateTournaments,
} from "app/slices/TournamentSlice";
import { nonUndefined } from "Utility";
import { tournamentCollectionName } from "./collectionNames";
import { Tournament } from "model/Tournament/Tournament";
import { daysToMs, getTimeMs } from "TimeHelper";
import { selectIsTournamentTracked } from "selectors/TournamentLoading";

let initialLoad = true;

const INITIAL_LOAD_DAY_THRESHOLD = 14;

const shouldTrackTournament = (tournament: Tournament) => {
  return (
    tournament.endTimeMs > getTimeMs() - daysToMs(INITIAL_LOAD_DAY_THRESHOLD)
  );
};

export const setupTournamentSnapshot = () => {
  onSnapshot(collection(db, tournamentCollectionName), (querySnapshot) => {
    const tournaments = nonUndefined(
      querySnapshot
        .docChanges()
        .map((d) => mapTournament(d.doc.data() as FsTournament, d.doc.id))
    );

    store.dispatch(
      updateTournaments({
        tournaments,
      })
    );

    const tournamentsToTrack = tournaments.filter(
      (t) =>
        shouldTrackTournament(t) &&
        (initialLoad || !selectIsTournamentTracked(store.getState(), t.id))
    );

    store.dispatch(
      trackTournaments({
        initialLoad,
        tournamentIds: tournamentsToTrack.map((t) => t.id),
      })
    );

    if (initialLoad) {
      initialLoad = false;
    }
  });
};
